import { render, staticRenderFns } from "./PlayerInfo.vue?vue&type=template&id=17403e95&scoped=true&"
import script from "./PlayerInfo.vue?vue&type=script&lang=js&"
export * from "./PlayerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17403e95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/usr/src/regapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
installComponents(component, {VDivider,VForm})
